module.exports = __webpack_public_path__ + "media/faq/cta-dfec4427.jpg";